<template>
  <div>
    <el-form
      :model="selectedTechProcess"
      ref="formedForm"
      label-position="top"
      label-width="120px"
      :rules="rules"
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            label="Наименование вида деятельности/технологического процесса"
          >
            <el-row
              :key="key"
              v-for="(objName, key) in selectedTechProcess.listName"
            >
              <el-col :span="7">
                <el-input v-model="objName.name"></el-input>
              </el-col>
              <el-col :span="7">
                <el-date-picker
                  v-model="objName.dateFrom"
                  type="date"
                  placeholder="Дата старта наименования"
                  value-format="yyyy-MM-dd"
                  format="dd.MM.yyyy"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </el-col>
              <el-col :span="7">
                <el-date-picker
                  v-model="objName.dateTo"
                  type="date"
                  placeholder="Дата конца наименования"
                  value-format="yyyy-MM-dd"
                  format="dd.MM.yyyy"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </el-col>
              <el-col :span="3">
                <el-button
                  @click="deleteLine(key)"
                  type="primary"
                  style="float: left"
                  >Удалить</el-button
                >
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-button @click="addLine" type="primary" style="float: left"
                  >Добавить</el-button
                >
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item
            prop="organizationInfo"
            label="Объект / Филиал / Подразделение / Участок"
          >
            <el-select
              style="width: 100%"
              clearable
              value-key="id"
              v-model="selectedTechProcess.organizationInfo"
              filterable
              placeholder="Выберите"
            >
              <el-option
                v-for="item in organizationHierarchyByType"
                :key="item.id"
                :label="item.name"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <br />
      <el-row>
        <el-date-picker
          v-model="selectedTechProcess.dateFrom"
          type="date"
          placeholder="Дата начала работы"
          value-format="yyyy-MM-dd"
          format="dd.MM.yyyy"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </el-row>
      <br />
      <el-row>
        <input
          type="checkbox"
          id="checkbox"
          v-model="selectedTechProcess.datEd"
        />
        <label for="checkbox">Устаревшее</label>
      </el-row>
      <el-row>
        <el-date-picker
          v-model="selectedTechProcess.dateTo"
          type="date"
          :disabled="!selectedTechProcess.datEd"
          placeholder="Выберите дату"
          value-format="yyyy-MM-dd"
          format="dd.MM.yyyy"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </el-row>
      <el-button @click="save" type="primary">Обновить</el-button>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "techprocessesEdit",
  props: ["selectedTechProcess", "action"],
  data() {
    return {
      pickerOptions:{
        firstDayOfWeek: 1
      },
      rules: {
        organizationInfo: [
          {
            required: true,
            message: "Заполните поле",
            trigger: "blur",
          },
        ],

        processName: [
          {
            required: true,
            message: "Заполните поле",
            trigger: "blur",
          },
        ],
      },
    };
  },

  computed: {
    ...mapGetters({
      organizationHierarchyByType: "GETORGANIZATIHIERARCHYBYTYPE",
    }),
  },

  methods: {
    deleteLine(index) {
      this.selectedTechProcess.listName.splice(index, 1);
    },
    addLine() {
      console.log(this);
      this.selectedTechProcess.listName.push({
        name: "",
        datEd: null,
        dateTo: null,
      });
    },
    save() {
      this.$refs["formedForm"].validate((valid) => {
        if (valid) {
          this.selectedTechProcess.processName =
            this.selectedTechProcess.listName[
              this.selectedTechProcess.listName.length - 1
            ].name;
          this.$store
            .dispatch("updateTechProcess", this.selectedTechProcess)
            .then(() => {
              this.notification("Успешно", "Тех. процесс добавлен", "success");
              this.$store.dispatch("setShowModal", null);
              this.$store.dispatch("getListAllTechProcesses", {
                page: this.action.page,
                size: this.action.size,
              });
            });
        }
      });
    },
  },
};
</script>

<style scoped></style>
